import health from "./health.json";
import tools from "./tools.json";
import phrasal from "./phrasal.json";
import emotions from "./emotions.json";
import business from "./business.json";

export const VOCABULARY_M9_U1 = [
    ...health,
    ...tools,
    ...phrasal,
    ...emotions,
    ...business,
];